import { Cloud, CloudOff, Clock, AlertCircle, MinusCircle } from "lucide-react";

const VARIANTS = {
  synced:    { label: "Synced",     cls: "bg-emerald-50 text-emerald-800 border-emerald-200", Icon: Cloud },
  pending:   { label: "Pending",    cls: "bg-amber-50  text-amber-800   border-amber-200",    Icon: Clock },
  failed:    { label: "Failed",     cls: "bg-rose-50   text-rose-800    border-rose-200",     Icon: AlertCircle },
  disabled:  { label: "Disabled",   cls: "bg-slate-100 text-slate-600   border-slate-200",    Icon: CloudOff },
  not_synced:{ label: "Not synced", cls: "bg-slate-50  text-slate-600   border-slate-200",    Icon: MinusCircle },
};

export default function DynamicsBadge({ value, className = "" }) {
  const key = !value ? "not_synced" : (VARIANTS[value] ? value : "not_synced");
  const v = VARIANTS[key];
  const Icon = v.Icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${v.cls} ${className}`}
      data-testid={`dynamics-badge-${key}`}
      title={`Dynamics: ${v.label}`}
    >
      <Icon size={10} />
      {v.label}
    </span>
  );
}

export const DYNAMICS_FILTER_OPTIONS = [
  { value: "all",        label: "All Dynamics" },
  { value: "synced",     label: "Synced" },
  { value: "pending",    label: "Pending" },
  { value: "failed",     label: "Failed" },
  { value: "disabled",   label: "Disabled" },
  { value: "not_synced", label: "Not synced" },
];
